import HttpClient from "@/common/boot/HttpClient"

const listarPrazosContratuais = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/ctrl-prazos-contratuais', payload);
    commit('LISTAR_DADOS', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

export {
  listarPrazosContratuais,
}
